import EntityEventLocation from "@/domain/entities/emails/EventLocation";
import { EventLocation } from "@cs_teamwaydev/mailvista-sdk_react";

const eventLocationMapper = (
    eventLocation: EventLocation,
): EntityEventLocation =>
    new EntityEventLocation({
        displayName: eventLocation.displayName,
        locationType: eventLocation.locationType,
        uniqueIdType: eventLocation.uniqueIdType,
        // latitude: eventLocation.latitude,  TODO : To be implemented in SDK
        // longitude: eventLocation.longitude,
    });

export default eventLocationMapper;
